(function () {
  const SEARCH_PARAM = 'q';
  const URL_DEBOUNCE_MS = 300;
  const SCROLL_DEBOUNCE_MS = 300;
  const SCROLL_OFFSET_PX = 24;

  const normalizeText = (value) => {
    return (value || '').toLowerCase().trim();
  };

  const initBlogCategoriesAccordion = (root) => {
    const panel = root.querySelector('[data-sss-categories-panel]');
    const toggle = root.querySelector('[data-sss-categories-toggle]');
    const body = root.querySelector('[data-sss-categories-body]');
    const desktopQuery = window.matchMedia('(min-width: 1200px)');

    if (!panel || !toggle || !body || panel.dataset.blogCategoriesBound === 'true') {
      return;
    }

    const setOpen = (isOpen) => {
      panel.classList.toggle('is-open', isOpen);
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      body.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    };

    const syncLayout = () => {
      if (desktopQuery.matches) {
        setOpen(true);
        body.removeAttribute('aria-hidden');
        return;
      }

      setOpen(panel.classList.contains('is-open'));
    };

    toggle.addEventListener('click', () => {
      if (desktopQuery.matches) {
        return;
      }

      setOpen(!panel.classList.contains('is-open'));
    });

    desktopQuery.addEventListener('change', syncLayout);
    panel.classList.add('is-open');
    syncLayout();
    panel.dataset.blogCategoriesBound = 'true';
  };

  const initBlogSearch = (root) => {
    const searchInput = root.querySelector('[data-blog-search]');
    const cards = root.querySelectorAll('[data-blog-card]');
    const emptyState = root.querySelector('[data-blog-search-empty]');
    const resultsAnchor = root.querySelector('[data-blog-results]');
    const pagination = root.querySelector('[data-blog-pagination]');

    if (!searchInput || !cards.length || searchInput.dataset.blogSearchBound === 'true') {
      return;
    }

    cards.forEach((card) => {
      const searchText = card.getAttribute('data-blog-search-text') || '';
      card.dataset.blogHaystack = normalizeText(searchText);
    });

    let urlDebounceTimer = null;
    let scrollDebounceTimer = null;

    const scrollToResults = () => {
      if (!resultsAnchor) {
        return;
      }

      const targetTop =
        resultsAnchor.getBoundingClientRect().top + window.scrollY - SCROLL_OFFSET_PX;

      window.scrollTo({
        top: Math.max(0, targetTop),
        behavior: 'smooth',
      });
    };

    const scheduleScrollToResults = () => {
      if (scrollDebounceTimer) {
        window.clearTimeout(scrollDebounceTimer);
      }

      scrollDebounceTimer = window.setTimeout(() => {
        scrollToResults();
        scrollDebounceTimer = null;
      }, SCROLL_DEBOUNCE_MS);
    };

    const writeUrlState = () => {
      const params = new URLSearchParams(window.location.search);
      const queryValue = searchInput.value.trim();

      if (queryValue) {
        params.set(SEARCH_PARAM, queryValue);
      } else {
        params.delete(SEARCH_PARAM);
      }

      const nextQuery = params.toString();
      const nextUrl = nextQuery
        ? `${window.location.pathname}?${nextQuery}${window.location.hash}`
        : `${window.location.pathname}${window.location.hash}`;

      window.history.replaceState(null, '', nextUrl);
    };

    const scheduleUrlUpdate = () => {
      if (urlDebounceTimer) {
        window.clearTimeout(urlDebounceTimer);
      }

      urlDebounceTimer = window.setTimeout(() => {
        writeUrlState();
        urlDebounceTimer = null;
      }, URL_DEBOUNCE_MS);
    };

    const applySearch = () => {
      const query = normalizeText(searchInput.value);
      let visibleCount = 0;

      cards.forEach((card) => {
        const haystack = card.dataset.blogHaystack || '';
        const isVisible = query === '' || haystack.indexOf(query) !== -1;

        card.classList.toggle('is-hidden', !isVisible);

        if (isVisible) {
          visibleCount += 1;
        }
      });

      if (emptyState) {
        if (query !== '' && visibleCount === 0) {
          emptyState.removeAttribute('hidden');
        } else {
          emptyState.setAttribute('hidden', '');
        }
      }

      if (pagination) {
        if (query !== '') {
          pagination.setAttribute('hidden', '');
        } else {
          pagination.removeAttribute('hidden');
        }
      }
    };

    const syncFromUrl = (shouldScroll) => {
      const params = new URLSearchParams(window.location.search);
      const searchParam = params.get(SEARCH_PARAM) || '';

      searchInput.value = searchParam;
      applySearch();

      if (shouldScroll && searchParam) {
        scrollToResults();
      }
    };

    searchInput.addEventListener('input', () => {
      applySearch();
      scheduleUrlUpdate();
      scheduleScrollToResults();
    });

    searchInput.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') {
        event.preventDefault();
      }
    });

    window.addEventListener('popstate', () => {
      syncFromUrl(true);
    });

    syncFromUrl(false);
    searchInput.dataset.blogSearchBound = 'true';
  };

  const initBlogList = (root) => {
    if (!root || root.dataset.blogListInitialized === 'true') {
      return;
    }

    initBlogCategoriesAccordion(root);
    initBlogSearch(root);
    root.dataset.blogListInitialized = 'true';
  };

  const boot = (scope) => {
    const root = scope && scope.matches && scope.matches('[data-blog-list]') ? scope : null;

    if (root) {
      initBlogList(root);
      return;
    }

    document.querySelectorAll('[data-blog-list]').forEach(initBlogList);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => boot(document));
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    boot(event.target);
  });
})();
